module.exports = __webpack_public_path__ + "assets/images/67fa0717af6454a8a5baacb37da748f2.svg";